module.exports = __webpack_public_path__ + "assets/img/5_1278_big.3e119306.jpg";